'use client';

import { c as _c } from "react/compiler-runtime";
import LoaderCircle from '@components/loader-circle/LoaderCircle';
import { activeQueueSelector } from '@lib/store/slices/VisualSlice';
import wordEndings from '@lib/tools/_word-endings';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import VisualFlatsInfo from 'src/app/visual/components/visual-flats-info/VisualFlatsInfo';
import BottomSheet from '../bottom-sheets/BottomSheet';
import QueuePlan from '../queue-plan/QueuePlan';
import ListLink from '../visual-bottom-links/ListLink/ListLink';
import NextLink from '../visual-bottom-links/NextLink/NextLink';
import VisualInfo from '../visual-info/VisualInfo';
import VisualNav from '../visual-nav/VisualNav';
import style from './VisualRootMobile.module.scss';
function VisualRootMobile(t0) {
  const $ = _c(43);
  const {
    visual,
    firstQueue,
    secondQueue,
    getActiveQueue,
    isMobile
  } = t0;
  const activeQueue = useSelector(activeQueueSelector);
  const sheetRef = useRef(null);
  let t1;
  if ($[0] !== activeQueue || $[1] !== visual?.bulks) {
    t1 = visual?.bulks?.filter(item => item.buildingPhase === activeQueue)[0];
    $[0] = activeQueue;
    $[1] = visual?.bulks;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const bulk = t1;
  if (!visual) {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <LoaderCircle />;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] !== activeQueue) {
    t2 = <div className={style.rightBlock__tabs}><VisualNav activeQueue={activeQueue} mobTabStyle={style.mobTabStyle} mobTabActiveStyle={style.mobTabActiveStyle} page={1} /></div>;
    $[4] = activeQueue;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== isMobile || $[7] !== visual) {
    t3 = <QueuePlan visualInfo={visual} sheetRef={sheetRef} someStyles={style.leftBlock} isMobile={isMobile} />;
    $[6] = isMobile;
    $[7] = visual;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className={style.listLink}><ListLink /></div>;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = activeQueue === null ? "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043E\u0447\u0435\u0440\u0435\u0434\u044C" : "\u041E\u0447\u0435\u0440\u0435\u0434\u044C " + activeQueue;
  let t6;
  if ($[10] !== t5) {
    t6 = <p className={style.title}>{t5}</p>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== activeQueue || $[13] !== visual.flats?.length) {
    t7 = activeQueue === null && <p className={style.description}>{`В продаже ${visual?.flats?.length} ${wordEndings(visual?.flats?.length)}`}</p>;
    $[12] = activeQueue;
    $[13] = visual.flats?.length;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== activeQueue || $[16] !== firstQueue) {
    t8 = activeQueue === 1 && <p className={style.description}>{`В продаже ${firstQueue.length} ${wordEndings(firstQueue.length)}`}</p>;
    $[15] = activeQueue;
    $[16] = firstQueue;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== activeQueue || $[19] !== secondQueue) {
    t9 = activeQueue === 2 && <p className={style.description}>{`В продаже ${secondQueue.length} ${wordEndings(secondQueue.length)}`}</p>;
    $[18] = activeQueue;
    $[19] = secondQueue;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== activeQueue || $[22] !== getActiveQueue || $[23] !== visual) {
    t10 = activeQueue !== null && <VisualInfo data={visual} activeBulk={getActiveQueue(activeQueue)} />;
    $[21] = activeQueue;
    $[22] = getActiveQueue;
    $[23] = visual;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== visual.flats) {
    t11 = <VisualFlatsInfo flats={visual.flats} />;
    $[25] = visual.flats;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== activeQueue || $[28] !== bulk?.id || $[29] !== visual) {
    t12 = activeQueue !== null && <NextLink visualInfo={visual} bulk={bulk?.id ? bulk?.id : 0} activeQueue={activeQueue} />;
    $[27] = activeQueue;
    $[28] = bulk?.id;
    $[29] = visual;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t10 || $[32] !== t11 || $[33] !== t12 || $[34] !== t6 || $[35] !== t7 || $[36] !== t8 || $[37] !== t9) {
    t13 = <BottomSheet><div className={style.rightBlock} ref={sheetRef}>{t4}{t6}{t7}{t8}{t9}{t10}{t11}{t12}</div></BottomSheet>;
    $[31] = t10;
    $[32] = t11;
    $[33] = t12;
    $[34] = t6;
    $[35] = t7;
    $[36] = t8;
    $[37] = t9;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== t13 || $[40] !== t2 || $[41] !== t3) {
    t14 = <><div className={style.wrapper}>{t2}{t3}{t13}</div></>;
    $[39] = t13;
    $[40] = t2;
    $[41] = t3;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  return t14;
}
export default VisualRootMobile;